import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { quadrant: String }

  connect() {
    this._lastIndicatorUpdate = 0
  }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
    this.element.classList.add('ring-2', 'ring-indigo-400', 'ring-inset', 'bg-indigo-50/50', 'dark:bg-indigo-900/10')

    const now = Date.now()
    if (now - this._lastIndicatorUpdate >= 50) {
      this._lastIndicatorUpdate = now
      this._showDropIndicator(event)
    }
  }

  dragleave(event) {
    if (!this.element.contains(event.relatedTarget)) {
      this._removeHighlight()
      this._removeDropIndicator()
    }
  }

  drop(event) {
    event.preventDefault()
    this._removeHighlight()
    this._removeDropIndicator()

    const taskId = event.dataTransfer.getData('text/plain')
    if (!taskId) return

    const draggedQuadrant = event.dataTransfer.getData('application/x-quadrant')
    const isSameQuadrant = draggedQuadrant === this.quadrantValue

    const { index: position, beforeElement } = this._getInsertPosition(event)
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    if (isSameQuadrant) {
      fetch(`/command_centre/tasks/${taskId}/reorder`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': csrfToken,
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: `position=${position}`
      }).then(response => {
        if (!response.ok) return
        // Physically move the turbo-frame in the DOM to match the new position
        const draggedFrame = this.element.querySelector(`turbo-frame[id*="${taskId}"]`) ||
                             document.getElementById(`command_centre_task_${taskId}`)?.closest('turbo-frame')
        if (draggedFrame) {
          if (beforeElement) {
            this.element.insertBefore(draggedFrame, beforeElement)
          } else {
            this.element.appendChild(draggedFrame)
          }
        }
      })
    } else {
      fetch(`/command_centre/tasks/${taskId}/move`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': csrfToken,
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: `quadrant=${this.quadrantValue}&position=${position}`
      }).then(response => {
        if (response.ok) return response.text()
      }).then(html => {
        if (html) Turbo.renderStreamMessage(html)
      })
    }
  }

  _getInsertPosition(event) {
    const frames = Array.from(this.element.querySelectorAll(':scope > turbo-frame'))

    for (let i = 0; i < frames.length; i++) {
      const rect = frames[i].getBoundingClientRect()
      const midY = rect.top + rect.height / 2
      if (event.clientY < midY) {
        return { index: i, beforeElement: frames[i] }
      }
    }

    return { index: frames.length, beforeElement: null }
  }

  _showDropIndicator(event) {
    this._removeDropIndicator()
    const { beforeElement } = this._getInsertPosition(event)
    const indicator = document.createElement('div')
    indicator.id = 'drop-indicator'
    indicator.className = 'h-0.5 bg-indigo-500 rounded-full mx-1 my-0.5'
    if (beforeElement) {
      beforeElement.parentNode.insertBefore(indicator, beforeElement)
    } else {
      this.element.appendChild(indicator)
    }
  }

  _removeDropIndicator() {
    const existing = document.getElementById('drop-indicator')
    if (existing) existing.remove()
  }

  _removeHighlight() {
    this.element.classList.remove('ring-2', 'ring-indigo-400', 'ring-inset', 'bg-indigo-50/50', 'dark:bg-indigo-900/10')
  }
}
